module.exports = __webpack_public_path__ + "static/img/Information.5ff2db9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Information.png
// module id = QtJd
// module chunks = 8